import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { QuestionsV3 } from '../../../classes/enum';
import { VideoInfoType } from '../../../models/dynamic-form-v3.models';

@Component({
  selector: 'bepatient-input-video-v3',
  templateUrl: './input-video.component.html',
  styleUrls: ['./input-video.component.scss'],
  standalone: false
})
export class InputVideoComponentV3 implements OnInit {
  @Input() question: QuestionsV3;
  @Input() readonly: Boolean;
  @Input() formGroup: UntypedFormGroup;
  @Input() color: string;

  video: VideoInfoType;

  constructor() {}

  ngOnInit(): void {
    if (this.question && this.question.video) {
      this.video = this.question.video;
    }
  }
}
